import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import OldBalance from "../DataGrid/OldBalance";

const OldBalancePage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header
        title="Old Balance Registration"
        subtitle="Manage The Old Balance"
      />
      <OldBalance />
    </Box>
  );
};

export default OldBalancePage;
